import { render, staticRenderFns } from "./LeadBoardDealForm.vue?vue&type=template&id=29625162&"
import script from "./LeadBoardDealForm.vue?vue&type=script&lang=js&"
export * from "./LeadBoardDealForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports